<template>
  <div class="centent">
    <div class="titlefont sevItemsKeys" >
      <div class="titleAnimation">
        <div class="title">新媒体行业真项目，盘他！</div>
      </div>
    </div>
    <div class="cont">
      <div class=" sevItemsKeys sevItems itemA">
        <div class="items" v-for="(value, index) in eighthScreen" :key="index">
          <div @click="goDetails(value.url)">
            <div class="divImg">
              <img
                src="../../../../../assets/cover.jpg"
                v-if="value.banner === null || value.banner.length === 0"
              />
              <img
                v-lazy="{
                  src: value.banner[0].url,
                  loading: require('./../../../../../assets/coverpic.jpg'),
                }"
              />
            </div>
            <div class="textInfo">
              {{ value.title }}
              <span v-if="value.subTitle !== null">
                <span class="fontBg">{{ value.BotTitle }}</span>
              </span>
            </div>
          </div>
          <!-- <div class="sevdialog">
                  {{ dialogData.title }}
                  <div class="title">{{ dialogData.title }}</div>
                  <p><span>项目介绍：</span>{{ dialogData.desc }}</p>
                  <p>
                    <span
                      >培养能力：
                      <em>{{ dialogData }}</em>
                    </span>
                  </p>
                </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    eighthScreen: {
      type: Array,
      required: true,
      default: () => {},
    },
    sevItemsKeys: {
      type: Boolean,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    // 项目专栏点击前往详情页
    goDetails(url) {
      console.log(url)
      if (url) {
        let routeUrl = this.$router.resolve({
          path: url,
        });
        window.open(routeUrl.href, "_blank");
      }
    },
  },
};
</script>
<style src="./../style.scss" rel="stylesheet/scss" lang="scss" scoped></style>
<style lang="scss" scoped>
</style>
